import { AxiosRequest } from "../../../Url";
import { getTableLayout } from "../../Tools/Requests";
import { getModalSectionID, getRightsData } from "../../Tools/Tools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";

export async function programsGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout({
    module: props.Module,
    objType: props.ObjType ? props.ObjType : "0",
    sectionId: props.SectionID,
    path: props.Path,
  });
  source.onHandleRequest = handleRequest(props);

  await source.open();

  if (json) {
    if (json.ReadOnly === "1") grid.OnlyViewMode = true;
    source.rights = json.Rights ? getRightsData(json.Rights) : getRightsData("-1");
    const columns = parseColumns(json);
    columns.title.forEach((field) => {
      if (field.fieldInfo?.options?.hidden) field.hide = true;
    });
    grid.setColumns(columns);
  } else grid.defaultColumns = true;

  await grid.setSource(source);

  if (props.ObjRef) await grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest(props) {
  return (request) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("Path", props.Path)
      .set("SectionID", props.SectionID ? props.SectionID : getModalSectionID());
    return AxiosRequest(true, params, request);
  };
}
